import React from 'react';
import PropTypes from 'prop-types';

import Text from '@zg-rentals/multibrand-ui/lib/Text';

export default function SectionComment({ applicantName, sectionComment }) {
  if (!sectionComment) {
    return null;
  }
  return (
    <div className="ApplicantSection__Row__Comment">
      <Text type="body-tiny">{`Note from ${applicantName || ''}:`}</Text>
      <Text className="Comment__Text">"{sectionComment}"</Text>
    </div>
  );
}

SectionComment.propTypes = {
  applicantName: PropTypes.string,
  sectionComment: PropTypes.string,
};

SectionComment.defaultProps = {
  applicantName: '',
  sectionComment: null,
};
